import history from '@chegg-wt/core-wa/utils/history/history'

export const keyboardEventHandler = (event) => {
  const { key, metaKey, shiftKey, ctrlKey } = event
  const isMac = navigator.userAgent.includes('Mac OS X')
  const isUndoKey = key === 'z' && (isMac ? metaKey : ctrlKey)
  const isRedoKey = isMac ? key === 'z' && shiftKey && metaKey : key === 'y' && ctrlKey

  if (isRedoKey) {
    history.applyRedo(true)
  } else if (isUndoKey) {
    history.applyUndo(true)
  }
}
